<template>
    <div>
        <div class="col-sm-12">
            <!-- Invoice To Selctor -->
            <div v-if="getIsDownloadingInvoiceResumeBulk" class="d-flex w-100 justify-content-center my-4">
                <loader></loader>
            </div>

            <div v-else class="mt-2 d-flex">
                <button @click="setInvoiceTo('customer')" :class="{ 'blue': invoiceTo == 'customer' }"
                    class="btn tertiary full super mr-3">Customer</button>
                <button @click="setInvoiceTo('agent')" :class="{ 'blue': invoiceTo == 'agent' }"
                    class="btn tertiary full super">Agent</button>
            </div>

            <!-- Value to invoice & Agent Picker -->
            <div class="mt-2 d-flex justify-content-end" v-if="invoiceTo">
                <div v-if="invoiceResumeBulk">
                    <label>
                        Amount to invoice
                    </label>

                    <div v-if="getIsDownloadingInvoiceResumeBulk">
                        <loader></loader>
                    </div>

                    <div v-else class="fs-large text-right darker bold">{{ formatPrice(valueToInvoice) }}€</div>
                </div>
            </div>

            <!-- Billing Info Form -->
            <div v-if="invoiceTo == 'agent'" class="row mt-2">
                <div class="col-sm-3">
                    <label :class="{ 'color-6': $v.invoiceToForm.vat.$invalid }">
                        VAT Number
                    </label>

                    <input type="text" class="full mb-3" v-model="invoiceToForm.vat">
                </div>

                <div class="col-sm-3">
                    <label :class="{ 'color-6': $v.invoiceToForm.city.$invalid }">
                        City <span v-if="isInvoiceValueOver" class="color-6">*</span>
                    </label>

                    <input type="text" class="full mb-3" v-model="invoiceToForm.city">
                </div>

                <div class="col-sm-3">
                    <label>
                        Postal Code
                    </label>

                    <input type="text" class="full mb-3" v-model="invoiceToForm.postalCode">
                </div>

                <div class="col-sm-3">
                    <label :class="{ 'color-6': $v.invoiceToForm.country.$invalid }">
                        Country <span v-if="isInvoiceValueOver" class="color-6">*</span>
                    </label>

                    <country-picker :openDirection="'bottom'" :selectedCountryValue="selectedCountry" :disabled="false" :allowEmpty="false" @input="updateCountry($event)"></country-picker>
                </div>

                <div class="col-sm-6">
                    <label :class="{ 'color-6': $v.invoiceToForm.businessName.$invalid }">
                        Billing name
                    </label>

                    <input type="text" class="full mb-3" v-model="invoiceToForm.businessName">
                </div>

                <div class="col-sm-6">
                    <label :class="{ 'color-6': $v.invoiceToForm.address.$invalid }">
                        Address <span v-if="isInvoiceValueOver" class="color-6">*</span>
                    </label>

                    <input type="text" class="full mb-3" v-model="invoiceToForm.address">
                </div>
            </div>

            <div class="d-flex align-items-center mt-4 mb-5" v-if="invoiceTo">
                <div class="flexGrow1 d-flex">
                    <div v-if="getIsPrintingInvoice" class="d-flex">
                        <loader></loader>
                        <div>Downloading invoice please wait</div>
                    </div>
                </div>
                
                <div class="col-5"> 
                    <v-select 
                        v-if="!getIsDocumentTypesLoading"
                        :options="documentTypesOptions"
                        label="label"
                        :value="documentTypeSelected"
                        @input="updateDocType"
                    />
                </div>

                <button class="btn blue wider text-nowrap"
                    :disabled="getIsCreatingInvoice || $v.$invalid || getIsPrintingInvoice || getIsDownloadingInvoiceResumeBulk || formatPrice(valueToInvoice) == 0 || formatPrice(valueToInvoice) == null"
                    @click="emitInvoices">Create Invoice(s)</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, email, minLength, requiredIf } from 'vuelidate/lib/validators'

import extendedVSelect from '@/extends/vue-select'
import SellerPicker from '@/tools/SellerPicker'
import Loader from '@/tools/loaders/loader1'
import CountryPicker from '@/tools/CountryPicker'

export default {
    async created() {
        this.getInvoiceResume();

        if (this.getDocumentTypes.length === 0) {
            await this.requestDocumentTypes();
        }
        
        this.documentTypeSelected = this.getDocumentTypes.find(item => item.isDefault);
    },
    props: {
        bulkObject: {
            type: Object
        }
    },
    data() {
        return {
            invoiceTo: null,
            selectedCountry: null,
            selectedAgent: null,
            invoiceToForm: {
                id: null,
                vat: null,
                city: null,
                postalCode: null,
                country: null,
                businessName: null,
                address: null,
                channelType: null,
                isOTA: null
            },
            invoiceResumeBulk: null,
            documentTypeSelected: null,
        }
    },
    computed: {
        ...mapGetters([
            'getCountries',
            'getAgents',
            'getIsDownloadingInvoiceResumeBulk',
            'getValueToAskMoreBillingInfo',
            'getIsCreatingInvoice',
            'getIsPrintingInvoice',
            'getIsDocumentTypesLoading',
            'getDocumentTypes'
        ]),
        documentTypesOptions() {
            return this.getDocumentTypes.filter(i => i.id !== 'PF' && i.id !== 'NC');
        },
        isInvoiceValueOver() {
            return this.valueToInvoice > this.getValueToAskMoreBillingInfo;
        },
        valueToInvoice() {
            if (this.getIsDownloadingInvoiceResumeBulk || !this.invoiceResumeBulk) {
                return false;
            }

            if (this.invoiceTo == 'customer') {
                return this.invoiceResumeBulk.invoiceRequestCustomer.total;
            } else if (this.invoiceTo == 'agent') {
                return this.invoiceResumeBulk.invoiceRequestAgent && this.invoiceResumeBulk.invoiceRequestAgent.total != null ? this.invoiceResumeBulk.invoiceRequestAgent.total : 0;
            }
        },
    },
    validations: {
        invoiceToForm: {
            vat: {
                // required
            },
            city: {
                required: requiredIf(function () { return this.isInvoiceValueOver })
            },
            country: {
                required: requiredIf(function () { return this.isInvoiceValueOver })
            },
            businessName: {
                // required
            },
            address: {
                required: requiredIf(function () { return this.isInvoiceValueOver })
            }
        },
    },
    methods: {
        ...mapActions([
            'emitInvoiceBulk',
            'downloadReservationInvoiceResumeBulk',
            'printInvoice',
            'requestDocumentTypes'
        ]),
        updateDocType(event) {
            this.documentTypeSelected = event;
        },
        setInvoiceTo(newInvoiceTo) {
            this.invoiceTo = newInvoiceTo;

            if (newInvoiceTo == 'customer') {
                this.fillFormWithCustomer();
            } else if (newInvoiceTo == 'agent') {
                this.fillFormWithAgent(this.selectedAgent);
            }
        },
        fillFormWithCustomer() {
            this.invoiceToForm = {
                id: null,
                vat: null,
                city: null,
                country: 176,
                businessName: null,
                address: null,
            }

            this.setCountry();
        },
        fillFormWithAgent(agent) {
            const otherSeller = this.getAgents.find(a => a.channelType == this.invoiceResumeBulk.channelType);
            const agentSeller = this.getAgents.find(a => a.id == this.invoiceResumeBulk.agentId);

            if (otherSeller && otherSeller.isOTA) {
                this.invoiceToForm = {
                    id: otherSeller.id,
                    vat: otherSeller.vat ? otherSeller.vat : otherSeller.taxpayerNumber,
                    city: otherSeller.location,
                    country: otherSeller.country.id,
                    businessName: otherSeller.billingName ? otherSeller.billingName : otherSeller.name,
                    address: otherSeller.address,
                    channelType: otherSeller.channelType,
                    isOTA: otherSeller.isOTA
                }
            }

            if (agentSeller && !agentSeller.isOTA) {
                this.invoiceToForm = {
                    id: agentSeller.id,
                    vat: agentSeller.vat ? agentSeller.vat : agentSeller.taxpayerNumber,
                    city: agentSeller.location,
                    country: agentSeller.country.id,
                    businessName: agentSeller.billingName ? agentSeller.billingName : agentSeller.name,
                    channelType: agentSeller.channelType == null ? this.invoiceResumeBulk.channelType : agentSeller.channelType,
                    isOTA: agentSeller.isOTA
                }
            }

            this.setCountry();
        },
        emitInvoices() {
            this.emitInvoiceBulk({
                invoiceToForm: this.invoiceToForm,
                invoiceTo: this.invoiceTo,
                selectedAgent: this.selectedAgent,
                documentType: this.documentTypeSelected.id
            }).then(response => {
                let numberOfCreatedInvoices = response.data.length;

                if (response.data[0] != null && numberOfCreatedInvoices > 0) {
                    this.$toasted.info(numberOfCreatedInvoices + 'Invoice/s created');

                    for (let invoice of response.data) {
                        if (invoice.invoicE_Url == null) {
                            this.printInvoice(invoice.id).then(response => {
                                if (response.status == 200) {
                                    this.openByteArrayNewTab(response.data);
                                    this.$emit('closeModal');
                                }
                            }).catch(err => {})
                        }
                        else {
                            window.open(invoice.invoicE_Url, "_blank");
                        }
                    }
                }
            })
        },
        getInvoiceResume() {
            this.downloadReservationInvoiceResumeBulk({
                invoiceToForm: this.invoiceToForm,
                invoiceTo: this.invoiceTo
            }).then(response => {
                if (response.status == 200) {
                    this.invoiceResumeBulk = response.data;
                }
            }).catch(() => {
                this.$emit('closeModal');
            });
        },
        // ------------  Helper  ------------
        updateCountry(e) {
            this.selectedCountry = e;
            
            if (e) {
                this.invoiceToForm.country = e.id;
            } else {
                this.invoiceToForm.country = null;
            }
        },
        setCountry(countryId) {
            if (!countryId && this.invoiceToForm.country) {
                countryId = this.invoiceToForm.country;
            }

            if (typeof countryId == "object") {
                countryId = countryId.id;
            }

            if (countryId === undefined) {
                this.selectedCountry = null;
                
                return false;
            }
            this.selectedCountry = this.getCountries.filter(country => {
                return country.id == countryId;
            })[0]
        },
    },
    components: {
        vSelect: extendedVSelect,
        SellerPicker,
        Loader,
        CountryPicker
    }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// areaInvoice.vue?aceb5afe